export default __webpack_public_path__ + "static/media/shop_fill.f486ac35.svg";